export class Catalogs {

  static #instance;

  catalogs;

  constructor() {

    this.catalogs = Object
      .freeze({
        TRACE_ID_HEADER: 'X-Trace-Id',
        MISSION_COMPLETE_HEADER: 'X-Mission-Complete',
        ORIGIN_TYPE: {
          LOCAL:   'LOCAL',
          FOREIGN: 'FOREIGN'
        },
        LEGAL_ENTITY_TYPE: {
          LEGAL:   'LEGAL',
          NATURAL: 'NATURAL'
        },
        CERTIFICATION_TYPE: {
          ESSENTIAL: 'ESS',
          STANDARD: 'STD',
          INTEGRAL: 'SPL',
          SPECIAL: 'SPL',
          ADVANCED: 'ADV'
        },
        CERTIFICATION_STATUS: {
          CERTIFIED: 'CERTIFIED',
          EXPIRED: 'EXPIRED'
        },
        FILTER_STATE: {
          ALL: Symbol(),
          LOCAL: Symbol(),
          FOREIGN: Symbol(),
          NEW: Symbol(),
          RENEWAL: Symbol(),
          CHANGE: Symbol(),
          UPDATE: Symbol(),
          INFORMATION: Symbol(),
          CHECKING_INFORMATION: Symbol(),
          INFORMATION_VALIDATED: Symbol(),
          DISCLAIMER: Symbol(),
          CHECKING_DISCLAIMER: Symbol(),
          CERTIFIED: Symbol()
        },
        TAX_REGIME: [
          {
            code: '601',
            description: 'Régimen general de ley personas morales'
          },
          {
            code: '602',
            description: 'Régimen simplificado de ley personas morales'
          },
          {
            code: '603',
            description: 'Personas morales con fines no lucrativos'
          },
          {
            code: '604',
            description: 'Régimen de pequeños contribuyentes'
          },
          {
            code: '605',
            description: 'Régimen de sueldos y salarios e ingresos asimilados a salarios'
          },
          {
            code: '606',
            description: 'Régimen de arrendamiento'
          },
          {
            code: '607',
            description: 'Régimen de enajenación o adquisición de bienes'
          },
          {
            code: '608',
            description: 'Régimen de los demás ingresos'
          },
          {
            code: '609',
            description: 'Régimen de consolidación'
          },
          {
            code: '610',
            description: 'Régimen residentes en el extranjero sin establecimiento permanente en méxico'
          },
          {
            code: '611',
            description: 'Régimen de ingresos por dividendos (socios y accionistas)'
          },
          {
            code: '612',
            description: 'Régimen de las personas físicas con actividades empresariales y profesionales'
          },
          {
            code: '613',
            description: 'Régimen intermedio de las personas físicas con actividades empresariales'
          },
          {
            code: '614',
            description: 'Régimen de los ingresos por intereses'
          },
          {
            code: '615',
            description: 'Régimen de los ingresos por obtención de premios'
          },
          {
            code: '616',
            description: 'Sin obligaciones fiscales'
          },
          {
            code: '617',
            description: 'Pemex'
          },
          {
            code: '618',
            description: 'Régimen simplificado de ley personas físicas'
          },
          {
            code: '619',
            description: 'Ingresos por la obtención de préstamos'
          },
          {
            code: '620',
            description: 'Sociedades cooperativas de producción que optan por diferir sus ingresos.'
          },
          {
            code: '621',
            description: 'Régimen de incorporación fiscal'
          },
          {
            code: '622',
            description: 'Régimen de actividades agrícolas, ganaderas, silvícolas y pesqueras pm'
          },
          {
            code: '623',
            description: 'Régimen de opcional para grupos de sociedades'
          },
          {
            code: '624',
            description: 'Régimen de los coordinados'
          },
          {
            code: '625',
            description: 'Régimen de las actividades empresariales con ingresos a través de plataformas tecnológicas' },
          {
            code: '626',
            description: 'Régimen simplificado de confianza'
          }
        ],
        LOCAL_COUNTRY_CODE: 'MX',
        LOCAL_PHONE_COUNTRY_CODE: '52',
        SECTIONS: {
          COMPANY_INFO:             'generalInformation',
          CONTACT_PERSON:           'contactPerson',
          PRODUCTS_AND_SERVICES:    'productsAndServices',
          MANAGEMENT_TEAM:          'teamManagement',
          FINANCIAL_INFO:           'financialInformation',
          MANAGEMENT_SYSTEM:        'systemManagement',
          INSURANCE_POLICIES:       'insurancePolicy',
          ETHICS_AND_COMPLIANCE:    'ethicsAndCompliance'
        },
        ALTERNATIVE_FLOW: {
          UPDATE: 'UPDATE',
          UPGRADE: 'UPGRADE',
          CHANGE_PLAN: 'CHANGE_PLAN',
          UPGRADING: 'UPGRADING',
          UPDATING: 'UPDATING',
          RENEWAL: 'RENEWAL',
          ACTIVE: 'ACTIVE',
          INACTIVE: 'INACTIVE'
        },
        REPSE_STATUS: {
          DEFAULT: 'DEFAULT',
          CURRENT: 'CURRENT',
          CANCELED: 'CANCELED'
        },
        USER_STATUS: {
          UNCONFIRMED:'UNCONFIRMED',
          ENABLE:'ENABLE',
          DISABLE:'DISABLE'
        },
        BUYER_STATUS: {
          ENABLED: 'ENABLE',
          DISABLED: 'DISABLE'
        },
        LANG: {
          SPANISH: {
            DESCRIPTION: 'Español',
            CODE: 'ES'
          },
          ENGLISH: {
            DESCRIPTION: 'Ingles',
            CODE: 'EN'
          }
        },
        STANDARD_PROPOSAL: __STANDARD_PROPOSAL_URL__,
      });
  }

  static getCatalogs() {

    if (!this.#instance) {
      this.#instance = new Catalogs();
    }

    return this.#instance.catalogs;
  }
}
